<summary-step-data [user]="record.user" [status]="record.status"></summary-step-data>
<div class="mat-small-header mb-1 px-3 mat-header-cell small d-flex">
  <div style="width: 20%">Line Item</div>
  <div style="width: 15%">Lead Time</div>
  <div style="width: 7.5%">Quantity</div>
  <div style="width: 10%">Unit Price</div>
  <div style="width: 10%">Ext. Price</div>
</div>
<mat-list class="pt-0 border-top list pb-2">
  <mat-list-item *ngFor="let lineItem of quoteLineItems" class="border-bottom item-outer">
      <div class="w-100 d-flex align-items-center item">
        <b
          style="width: 20%"
          [innerHTML]=" this.getLineItemName(lineItem) | highlight: highlightFilter : '\<span class=\'msr-highlight\'\>' : '\</span\>' "
        ></b>
        <div style="width: 15%">{{lineItem.leadTimeDays}} working days/{{toWeeks(lineItem.leadTimeDays)}} weeks</div>
        <div style="width: 7.5%">{{lineItem.quantity}}</div>
        <div style="width: 10%">{{ lineItem.unitPrice | currency }} </div>
        <div style="width: 10%">{{ lineItem.extPrice | currency }}</div>
      </div>
  </mat-list-item>
</mat-list>